import React from 'react';

export const MediaContext = React.createContext({
  filesMetadata: [],
  selectedFiles: [],
  refreshFilesMetadata: () => {},
  onSelectSingleImage: () => {},
  onSelectMultipleImages: () => {},
  gmbLocation: null,
});

export const MediaContextProvider = MediaContext.Provider;
